var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabMap = function SvgTabMap(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4528",
    width: 32,
    height: 32,
    viewBox: "0 0 8.467 8.467",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -288.53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1241",
    fill: "currentColor",
    d: "M16 0A16 16 0 0 0 0 16a16 16 0 0 0 16 16 16 16 0 0 0 16-16A16 16 0 0 0 16 0m0 5c4.142 0 7.5 3.358 7.5 7.5S16 28.148 16 28.148 8.5 16.642 8.5 12.5A7.5 7.5 0 0 1 16 5m0 4a3.5 3.5 0 0 0-3.5 3.5A3.5 3.5 0 0 0 16 16a3.5 3.5 0 0 0 3.5-3.5A3.5 3.5 0 0 0 16 9",
    transform: "translate(0 288.53)scale(.26458)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabMap);
export default ForwardRef;